export default "__VITE_ASSET__BhqnQMSe__"